import { STATE_COLORS } from './statusColors';

// Mirrors src/Domain/Enums/MembershipStatus.cs — values must match the backend exactly.
export const MEMBERSHIP_STATUS = Object.freeze({
  PENDING: 'Pending',
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
});

export const MEMBERSHIP_STATUS_COLORS = Object.freeze({
  [MEMBERSHIP_STATUS.PENDING]: STATE_COLORS.INPROGRESS,
  [MEMBERSHIP_STATUS.ACTIVE]: STATE_COLORS.COMPLETE,
  [MEMBERSHIP_STATUS.SUSPENDED]: STATE_COLORS.ERROR,
});
